import React, { Component } from 'react'
import { Modal, ModalBody, ModalHeader, ModalFooter, Button, NavItem } from 'reactstrap'


class PrivacyPolicy extends Component {
  constructor(props) {
    super(props)

    this.state = {
      PrivacyPolicyModel: false
    }

    this.PrivacyPolicyToggle = this.PrivacyPolicyToggle.bind(this)
  }

  PrivacyPolicyToggle(event) {
    event.preventDefault()
    const { PrivacyPolicyModel } = this.state
    this.setState({
      ...this.state,
      PrivacyPolicyModel: !PrivacyPolicyModel
    })
  }

  render() {
    return (
      <div >

        <NavItem className="d-md-down-none">
          <a href="/#" className="nav-link" onClick={this.PrivacyPolicyToggle}>  Privacy Policy </a>
        </NavItem>

        <Modal isOpen={this.state.PrivacyPolicyModel} size={"lg"} toggle={this.PrivacyPolicyToggle} className={this.props.className}>
          <ModalHeader toggle={this.PrivacyPolicyToggle}>Privacy Policy</ModalHeader>
          <ModalBody>
            <p>Lorem ix`psum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
                            labore et dolore magna aliqua.</p> <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
                            labore et dolore magna aliqua.</p> <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
                            labore et dolore magna aliqua.</p>

          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.PrivacyPolicyToggle}>Close</Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default PrivacyPolicy
